import { DropDownList } from "@progress/kendo-react-dropdowns"
import { Checkbox, CheckboxChangeEvent } from "@progress/kendo-react-inputs"
import { useLocalization } from "@progress/kendo-react-intl";
import { useState } from "react";


export const FirstSequence = () => {

    const localizationService = useLocalization();

    const [checkedFirstSequence, setCheckedFirstSequence] = useState<boolean | null | undefined>(false);

    const [firstRedValue, setFirstRedValue] = useState<any>([]);
    const [firstGreenValue, setFirstGreenValue] = useState<any>([]);
    const [firstBlueValue, setFirstBlueValue] = useState<any>([]);
    const [firstBuzzerValue, setFirstBuzzerValue] = useState<any>([]);
    const [firstVibrationValue, setFirstVibrationValue] = useState<any>([]);
    const [durationValueSelected, setDurationValueSelected] = useState<any>([]);

    var redValues:any, greenValues:any, blueValues:any, buzzzerValue:any, vibrationValue:any = [];

    redValues = greenValues = blueValues = buzzzerValue = vibrationValue = {
        "data": [
            {
                "id": 0,
                "name": 'ON'
            },
            {
                "id": 1,
                "name": 'OFF'
            },
            {
                "id": 2,
                "name": 'LF'
            },
            {
                "id": 3,
                "name": 'HF'
            }
        ]
    }

    const durationValue = {
        "data": [
            {
                "id": 0,
                "name": '1s'
            },
            {
                "id": 1,
                "name": '0'
            },
            {
                "id": 2,
                "name": '500ms'
            },
            {
                "id": 3,
                "name": '2s'
            }
        ]
    }

    const handleFirstSequence = (event: CheckboxChangeEvent) => {
        setCheckedFirstSequence(event.value);
    };

    const onFirstRedValueChange = (event: any) => {
        setFirstRedValue(event.value)
    }

    const onFirstGreenValueChange = (event: any) => {
        setFirstGreenValue(event.value)
    }

    const onFirstBlueValueChange = (event: any) => {
        setFirstBlueValue(event.value)
    }

    const onFirstBuzzerValueChange = (event: any) => {
        setFirstBuzzerValue(event.value)
    }

    const onFirstVibrationValueChange = (event: any) => {
        setFirstVibrationValue(event.value)
    }

    const onFirstDurationValueChange = (event: any) => {
        setDurationValueSelected(event.value)
    }
    
    return (

        <div style={{ display: 'inline-flex', width: '100%' }}>

            <div style={{ color: '#1A8995', textAlign: 'left', margin: '25px 0px 0px 0px' }}>{localizationService.toLanguageString('configuration.rules.subscription_backchannel_enabled', 'NOT_FOUND')}</div>
            <Checkbox
                //label={localizationService.toLanguageString('configuration.rules.subscription_backchannel_enabled', 'NOT_FOUND')}
                checked={checkedFirstSequence}
                style={{ marginTop: '30px', marginRight: '20px', marginLeft: '10px' }}
                onChange={handleFirstSequence}
            />

            <div style={{ display: 'inline', marginRight: '10px', marginLeft: '10px', width: '105px' }}>
                <div style={{ textAlign: 'left', color: 'red' }}>{localizationService.toLanguageString('configuration.rules.subscription_backchannel_red', 'NOT_FOUND')}</div>
                <DropDownList
                    data={redValues.data?.map((value: any) => {
                        return (
                            value.name
                        )
                    })}
                    onChange={onFirstRedValueChange}
                />
            </div>
            <div style={{ display: 'inline', marginRight: '10px', width: '105px' }}>
                <div style={{ textAlign: 'left', color: 'green' }}>{localizationService.toLanguageString('configuration.rules.subscription_backchannel_green', 'NOT_FOUND')}</div>
                <DropDownList
                    data={redValues.data?.map((value: any) => {
                        return (
                            value.name
                        )
                    })}
                    onChange={onFirstRedValueChange}
                />
            </div>
            <div style={{ display: 'inline', marginRight: '10px', width: '105px' }}>
                <div style={{ textAlign: 'left', color: 'blue' }}>{localizationService.toLanguageString('configuration.rules.subscription_backchannel_blue', 'NOT_FOUND')}</div>
                <DropDownList
                    data={redValues.data?.map((value: any) => {
                        return (
                            value.name
                        )
                    })}
                    onChange={onFirstBlueValueChange}
                />
            </div>
            <div style={{ display: 'inline', marginRight: '10px', width: '105px' }}>
                <div style={{ textAlign: 'left' }}>{localizationService.toLanguageString('configuration.rules.subscription_backchannel_buzzer', 'NOT_FOUND')}</div>
                <DropDownList
                    data={redValues.data?.map((value: any) => {
                        return (
                            value.name
                        )
                    })}
                    onChange={onFirstBuzzerValueChange}
                />
            </div>
            <div style={{ display: 'inline', marginRight: '10px', width: '105px' }}>
                <div style={{ textAlign: 'left' }}>{localizationService.toLanguageString('configuration.rules.subscription_backchannel_vibration', 'NOT_FOUND')}</div>
                <DropDownList
                    data={redValues.data?.map((value: any) => {
                        return (
                            value.name
                        )
                    })}
                    onChange={onFirstVibrationValueChange}
                />
            </div>
            <div style={{ display: 'inline', marginRight: '10px', width: '120px' }}>
                <div style={{ textAlign: 'left' }}>{localizationService.toLanguageString('configuration.rules.subscription_backchannel_duration', 'NOT_FOUND')}</div>
                <DropDownList
                    data={durationValue.data?.map((value: any) => {
                        return (
                            value.name
                        )
                    })}
                    onChange={onFirstDurationValueChange}
                />
            </div>

        </div>
    )
}